// packages/kern/src/styles.ts — Farben und Stile (SPEC §3.5).
//
// KEIN DOM: außer `text-canvas.ts` darf keine Datei in `packages/kern/src`
// `document`, `window`, `navigator`, `fetch`, `localStorage` oder einen
// React-Import enthalten.
//
// Diese Werte sind das Druckerzeugnis: nicht themebar, nicht responsiv, nicht
// verhandelbar (E7, T23). Die CSS-Tokens --paper, --petrol, --chart-muted,
// --chart-band, --chart-ferien, --chart-akzent, --chart-soft in tokens.css
// tragen DIESELBEN Werte. Wer hier etwas ändert, ändert es dort mit.

import type { StilKey } from "./types";

export const PETROL = "#045863";
export const PAPER = "#FAF8F4";
export const CMUTED = "#6F6F6D";
export const BAND = "#EDEDED";
export const FERIEN_FILL = "#B7CDD1";   // = #0A5A64 bei 30 % auf Off-White
export const AUSWAHL = "#0A7A88";       // Auswahlrahmen + Griffe, nur im Editor

/** EINE Chart-Schrift (T22). 'Futura PT' ist ABSICHTLICH nicht dabei. */
export const CHART_FAM = "'Poppins', system-ui, -apple-system, 'Segoe UI', sans-serif";

export interface Stil {
  label: string;
  fill: string;          // "none" moeglich
  ink: string;
  stroke: string | null;
  sw?: number;
  dash?: string;
  italic: boolean;
  weight: number;
}

export const STYLES: Record<StilKey, Stil> = {
  solid:   { label: "Gefüllt",      fill: PETROL,    ink: "#FFFFFF", stroke: null,   italic: false, weight: 500 },
  soft:    { label: "Gefüllt hell", fill: "#DCE7E9", ink: PETROL,    stroke: null,   italic: false, weight: 400 },
  outline: { label: "Kontur",       fill: PAPER,     ink: PETROL,    stroke: PETROL, sw: 1,   italic: true,  weight: 400 },
  dashed:  { label: "Gestrichelt",  fill: "none",    ink: PETROL,    stroke: PETROL, sw: 1, dash: "4 3", italic: true, weight: 400 },
  meilen:  { label: "Meilenstein",  fill: PAPER,     ink: PETROL,    stroke: PETROL, sw: 0.9, italic: false, weight: 400 },
  grau:    { label: "Grau",         fill: CMUTED,    ink: "#FFFFFF", stroke: null,   italic: false, weight: 400 },
  akzent:  { label: "Akzent",       fill: "#A06532", ink: "#FFFFFF", stroke: null,   italic: false, weight: 500 },
  ghost:   { label: "Nur Text",     fill: "none",    ink: PETROL,    stroke: null,   italic: false, weight: 400 },
};

/** Textfarbe zu einer eigenen Fuellfarbe. Schwelle 150 wie im Prototyp. */
export function isDark(hex: string): boolean {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return true;
  const n = parseInt(m[1]!, 16);
  return 0.299 * ((n >> 16) & 255) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255) < 150;
}
